<template>
  <section
    class="mt-30 bg-primary-50 flex items-center justify-center py-30 border-t border-gray-300"
  >
    <div class="w-full max-w-[660px] mx-10 text-lg text-blue-900 text-center">
      <AlvaManager v-slot="{ poseQuestion, consentBoxShown }">
        <div
          v-if="!consentBoxShown"
          class="h-[250px] flex flex-col items-center justify-center"
        >
          <h3 class="font-bold">
            {{ $texts('alva.manualInputTitle', 'Nicht fündig geworden?') }}
          </h3>
          <p class="mb-30">
            {{
              $texts(
                'alva.manualInputLead',
                'Fragen Sie unseren KI-Assistenten Alva',
              )
            }}
          </p>

          <SearchInput
            class="w-full"
            :label="$texts('alva.manualInputLabel', 'Ihre Frage')"
            :aria-label="$texts('alva.manualInput', 'Ihre Frage eingeben')"
            :cta-label="$texts('alva.manualInputPoseQuestion', 'Frage stellen')"
            :placeholder="$texts('alva.manualInputPlaceholder', 'Ihre Frage')"
            :get-suggestions="getSuggestionsStub"
            submit-button-icon="arrow-north"
            submit-button-display="icon-only"
            submit-button-style="grey"
            @update:model-value="
              (v: string) => (v.length > 0 ? poseQuestion(v) : '')
            "
          />
        </div>
      </AlvaManager>
    </div>
  </section>
</template>

<script lang="ts" setup>
function getSuggestionsStub() {
  return Promise.resolve([])
}
</script>
